var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnWarningYellow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 8.84375V6.15625H7.34375V8.84375H8.65625ZM8.65625 11.5V10.1562H7.34375V11.5H8.65625ZM0.65625 13.5L8 0.84375L15.3438 13.5H0.65625Z",
    fill: "#FFC200"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnWarningYellow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-warning-yellow.388914fa.svg";
export { ForwardRef as ReactComponent };